import api from '../../plugins/api';

const getEngineCar = (params) => {
  return api.get('/api/shop/getEngineCar', params);
};

export default getEngineCar;
